import React from "react";

const HeroSection = ({ activeTab, setActiveTab, tabs }) => {
  return (
    <section className="w-full flex flex-col items-center">
      <div className="max-w-[1000px] w-full flex justify-center sm:justify-between items-center px-4 space-x-4 sm:space-x-6 mt-3">
        {tabs.map((tab) => {
          const isActive = activeTab === tab.name;
          // pick animated GIF when active, static PNG when not
          const src = isActive ? tab.gif : tab.still;

          return (
            <div
              key={tab.name}
              onClick={() => setActiveTab(tab.name)}
              className={`
                flex flex-col items-center cursor-pointer
                transition-opacity duration-200
                ${isActive ? "opacity-100" : "filter grayscale opacity-50"}
              `}
            >
              <img
                src={src}
                alt={tab.name}
                className="w-12 h-12 sm:w-[70px] sm:h-[70px] object-contain"
              />

              <span
                className={`text-sm font-medium mt-2 ${
                  isActive ? "text-blue-500" : "text-gray-500"
                }`}
              >
                {tab.name === "Members" ? "Member" : tab.name}
              </span>

              {isActive && (
                <div className="h-[3px] w-[40px] bg-blue-500 mt-1 rounded-full"></div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default HeroSection;
